import type { useAsyncRentalData } from '~/composables/use-async-rental-data'
import { getRentalDataKey } from '~/composables/use-async-rental-data'

export function useFetchedRentalData() {
    const route = useRoute()
    const rentalKey = getRentalDataKey(route)

    return (useNuxtData(rentalKey) as ReturnType<typeof useAsyncRentalData>)?.data?.value
}
